import { CartBadge } from 'cart';
import classNames from 'classnames';
import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './CartButton.scss';
const cartIcon = require('theme/icons/cart.svg');
function CartButton({ cartCount, hasUnavailableProducts, isActive = false, onClick, }) {
    const classes = classNames({
        'cart-button': true,
        'cart-button--unavailable-products': hasUnavailableProducts,
        'cart-button--active': isActive,
    });
    const { t } = useTranslation();
    return (React.createElement(Button, { variant: "tertiary", className: classes, ariaLabel: t('cartOpenCart'), onClick: onClick },
        React.createElement(Icon, { svg: cartIcon, size: "medium" }),
        React.createElement(CartBadge, { count: cartCount, hasUnavailableProducts: hasUnavailableProducts })));
}
export default CartButton;
